import { http } from "../http/Http";
import { ServiceResponse } from "../models/ServiceResponse";
import { GetByFiltersArguments } from "../models/GetByFiltersArguments";
import { PartnerTypeFieldsPermission } from "..";

export class PartnerTypeFieldsPermissionService {

    getPartnerTypeFieldsPermissionByFilters = async (apiQueryFilter: GetByFiltersArguments): Promise<ServiceResponse<PartnerTypeFieldsPermission[]>> => {
        const { data } = await http.post<ServiceResponse<PartnerTypeFieldsPermission[]>>("PartnerTypeFieldsPermission/GetByFilters", apiQueryFilter);
        return data;
    };

    getPartnerTypeFieldsPermission = async (id: number): Promise<PartnerTypeFieldsPermission> => {
        const { data } = await http.get<PartnerTypeFieldsPermission>(("PartnerTypeFieldsPermission/GetById/" + id.toString()));
        return data;
    };

    GetForCurrentUserPartnerType = async (): Promise<PartnerTypeFieldsPermission[]> => {
        const { data } = await http.get<PartnerTypeFieldsPermission[]>("PartnerTypeFieldsPermission/GetForCurrentUserPartnerType");
        return data;
    };

    addPartnerTypeFieldPermission = async (partnerTypeFieldsPermission: PartnerTypeFieldsPermission): Promise<PartnerTypeFieldsPermission> => {
        const { data } = await http.post<PartnerTypeFieldsPermission>("PartnerTypeFieldsPermission/Post", partnerTypeFieldsPermission);
        return data;
    };

    updatePartnerTypeFieldPermission = async (partnerTypeFieldsPermission: PartnerTypeFieldsPermission): Promise<PartnerTypeFieldsPermission> => {
        const { data } = await http.put<PartnerTypeFieldsPermission>("PartnerTypeFieldsPermission/Put", partnerTypeFieldsPermission);
        return data;
    };
}